import { useEffect, useState } from "react";
import useStyles from "../../assets/styles/styles";
import { Divider, FormControl, IconButton, Typography, Box } from "@material-ui/core";
import { getDataFilterAppointment } from "../../redux/actions/appointmentsActions";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../controls/Select/CustomSelect";
import NotFound from "../../components/HomeLogged/NotFound";
import CustomButton from "../../controls/Button/CustomButton";
import MovementsCard from "../../components/Billing/Movements/MovementsCard";
import HeaderCard from "../../components/Billing/Movements/HeaderCard";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ModalActivities from "../DialogActivities/ModalActivities";
import FileDownloadIcon from '@material-ui/icons/FileDownload';
import {
    getRefunds,
    downloadRefund,
    cancelRefundRequest,
    getParametersRefunds,
    setFilters,
    resetRefundError
} from "../../redux/actions/refundsActions";
import { useHistory } from "react-router";
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import { format } from "date-fns";
import { CircularProgress } from "@mui/material";
import CancelIcon from '@material-ui/icons/Cancel';
import { showErrorMessageModalRetry } from "../../utils/utilsFunctions";
import ShowPeriodFilter from "../../components/ShowPeriodFilter/ShowPeriodFilter";

const personNumber = parseInt(window.localStorage.getItem("numeroPersona"));

const person = {
    numeroPersona: personNumber,
    parametroLlamado: ""
};

const previousSixMonths = 6;

const RefundsIndex = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const date = new Date();
    const { screen } = useResizeScreen();
    const classes = useStyles();
    const [groupFamily, setGroupFamily] = useState([]);
    const [listCard, setListCard] = useState([]);
    const [openPicker, setOpenPicker] = useState(false);
    const refundsRedux = useSelector((state) => state.refundsReducer);
    const appointments = useSelector((state) => state.appointmentsReducer);
    const [openModal, setOpenModal] = useState(false);
    const [itemSelected, setItemSelected] = useState({});
    const downloadRefundAffiliate = useSelector((state) => state.refundsReducer.downloadRefund);
    const [openCancelRefundModal, setOpenCancelRefundModal] = useState(false);
    const [cancelRefund, setCancelRefund] = useState({});
    const [openLoadingModal, setLoadingModal] = useState(false);
    const loadingDownload = useSelector((state) => state.refundsReducer.loadingDownload);
    const [cancelRefundDownload, setCancelRefundDownload] = useState(false);
    const nullifyRefund = useSelector((state) => state.refundsReducer.cancelRefund);
    const [openNullifyRefundModal, setNullifyRefundModal] = useState(false);
    const [ErrorModal, setErrorModal] = useState(false);
    const [ErrorDownloadModal, setErrorDownloadModal] = useState(false);
    const { refundsFilters } = useSelector(state => state?.refundsReducer);
    const errorMessage = useSelector(state => state.refundsReducer.msgError);
    const [openErrorModal, setOpenErrorModal] = useState();


    const handleChange = () => e => {
        setListCard([]);
        let nameAffilliated = groupFamily?.filter((x) => x.value == e.target.value);
        dispatch(setFilters({ ...refundsFilters, afiliado: { value: nameAffilliated?.[0]?.value, label: nameAffilliated?.[0]?.label } }));
    };


    const handleStartRequest = (e) => {
        e.preventDefault();
        history.push('/Refunds?type=RefundsRequest');
    };

    const handleClickModal = (item) => e => {
        e.preventDefault();
        let obj = {
            numeroPersona: refundsFilters?.afiliado?.value,
            gestionCodigo: item?.reintegroGestionCodigo,
            reintegroNumero: item?.reintegroNumero,
            reintegroDelegacionCodigo: item?.reintegroDelegacionCodigo
        };
        dispatch(downloadRefund(obj));
    };

    function handleCloseDownload() {
        setCancelRefundDownload(true);
        setLoadingModal(false)
    }

    useEffect(() => {
        if (loadingDownload) {
            setLoadingModal(true);
            setCancelRefundDownload(false);
        } else {
            if (!cancelRefundDownload && downloadRefundAffiliate?.confirmacion) {
                setOpenModal(true);
                setLoadingModal(false);
            }
        }

        if (!downloadRefundAffiliate?.confirmacion && downloadRefundAffiliate?.confirmacion !== undefined) {
            setLoadingModal(false);
            setOpenModal(false);
            setErrorDownloadModal(true);
        }
    }, [loadingDownload])

    const setItemToCancel = item => {
        setCancelRefund(item);
        setOpenCancelRefundModal(true);
    }

    const handleClickCancelRefund = () => e => {
        e.preventDefault();
        let cancelActualItem = {
            numeroPersona: refundsFilters?.afiliado?.value,
            gestionCodigo: cancelRefund?.reintegroGestionCodigo
        };
        dispatch(cancelRefundRequest(cancelActualItem));
        setOpenCancelRefundModal(false);
        dispatch(getParametersRefunds());
        setCancelRefund({})
        setNullifyRefundModal(true);
    };

    useEffect(() => {
        if (nullifyRefund?.confirmacion) {
            setListCard([]);
            getAllRefunds();
        } else {
            if (!nullifyRefund?.confirmacion && nullifyRefund?.confirmacion !== undefined) {
                setNullifyRefundModal(false);
                setErrorModal(true);
            }
        }
    }, [nullifyRefund])

    useEffect(() => {
        dispatch(getDataFilterAppointment(person));
        setItemSelected({});
        setErrorDownloadModal(false);
        setErrorModal(false);
        setCancelRefundDownload(false);
        setLoadingModal(false);
        setOpenModal(false);
        setCancelRefund(false);
        validateInitialValues();
    }, []);

    useEffect(() => {
        if (downloadRefundAffiliate?.reintegro !== undefined) {
            setItemSelected({ archivo: downloadRefundAffiliate?.reintegro?.[0]?.archivo, archivoNombreCompleto: downloadRefundAffiliate?.reintegro?.[0]?.archivoNombreCompleto });
        }
    }, [downloadRefundAffiliate]);

    useEffect(() => {
        let listGroupFamily = appointments?.filtro?.map((val) => {
            return {
                value: parseInt(val?.numeroPersona), label: val?.apellidoNombre
            };
        });
        setGroupFamily(listGroupFamily);
    }, [appointments?.filtro]);

    useEffect(() => {
        groupFamily?.forEach((item) => {
            if (item?.value == personNumber && !refundsFilters?.afiliado) {
                dispatch(setFilters({ ...refundsFilters, afiliado: { value: item?.value, label: item?.label } }));
            }
        });
    }, [groupFamily]);

    const getAllRefunds = () => {
        if (refundsFilters?.dateStart && refundsFilters?.dateEnd && refundsFilters?.afiliado?.value) {
            let start = format(refundsFilters?.dateStart != undefined ? refundsFilters?.dateStart : date.setMonth(date.getMonth() - previousSixMonths), 'yyyy-MM-dd');
            let end = format(refundsFilters?.dateEnd != undefined ? refundsFilters?.dateEnd : new Date(), 'yyyy-MM-dd');
            let refundsRequest = {
                fechaDesde: start,
                fechaHasta: end,
                numeroPersona: refundsFilters?.afiliado?.value,
                count: 0,
                skip: 0
            };
            dispatch(getRefunds(refundsRequest));
        }
    }

    useEffect(() => {
        getAllRefunds();
    }, [refundsFilters?.dateStart, refundsFilters?.dateEnd, refundsFilters?.afiliado?.value]);

    useEffect(() => {
        let refundsCards = [];
        if (refundsRedux?.refunds?.reintegros?.length > 0) {
            refundsCards = refundsRedux?.refunds?.reintegros?.map(element => {
                return element;
            });
        }
        setListCard(refundsCards);
        setNullifyRefundModal(false);
    }, [refundsRedux?.refunds]);

    useEffect(() => {
        if (errorMessage !== "" && errorMessage !== undefined) {
            setOpenErrorModal(true);
            setNullifyRefundModal(false);
            setOpenCancelRefundModal(false);
            setErrorDownloadModal(false);
            setOpenModal(false);
            setLoadingModal(false);
            setErrorModal(false);
        }
    }, [errorMessage]);

    const goToFrequentQuestions = () => {
        history.push("/RefundsFAQ");
    };

    const setButtons = item => {
        let response = '';

        const STATE = {
            Ingresada: 'ANULAR',
            'En Proceso': '',
            Finalizado: '',
            Anulada: '',
            Autorizado: 'DESCARGAR',
            Denegado: '',
            Pagado: 'DESCARGAR',
        };

        const BTN = {
            DESCARGAR: (
                <CustomButton
                    title="DESCARGAR"
                    customClass={`${classes.lightLinearGradient} ${classes.downloadRefundsButton}`}
                    onClick={handleClickModal(item)}
                />
            ),

            ANULAR: (
                <CustomButton
                    title="ANULAR"
                    customClass={`${classes.lightLinearGradient} ${classes.downloadRefundsButton}`}
                    onClick={() => { setItemToCancel(item) }}
                />
            )
        };

        if (item?.reintegroEstadoDescripcion?.trim()) {
            response = BTN[STATE[item?.reintegroEstadoDescripcion?.trim()]];
        }

        return response;
    };

    const startRequestButton = () => {
        return (
            <Box className={classes.newRequestRefundsContainerButton}>
                <CustomButton
                    title={"Iniciar solicitud"}
                    onClick={handleStartRequest}
                    icon={<AddCircleIcon style={{ marginRight: "5px" }} />}
                    customClass={`${classes.customHeaderBtn} ${classes.buttonStartRequest}`}
                />
            </Box>
        );
    }

    const affiliateDropDown = () => {
        return (
            <Box style={{ minWidth: '240px' }}>
                <FormControl
                    className={`${classes.formControlChronicMedicationForm} ${classes.formControlsEmergency} ${classes.formControlSelect}`}
                    variant="standard"
                >
                    <CustomSelect
                        customRequired={true}
                        list={groupFamily}
                        selected={parseInt(refundsFilters?.afiliado?.value)}
                        onChange={handleChange()}
                    />
                </FormControl>
            </Box>
        );
    }

    const frequentQuestionsButton = () => {
        return (
            <Box>
                <CustomButton
                    title={screen.sWidth > 768 ? 'Preguntas Frecuentes' : ''}
                    onClick={goToFrequentQuestions}
                    icon={<QuestionAnswerOutlinedIcon style={{ marginRight: screen.sWidth > 768 ? "8px" : "5px" }} />}
                    customClass={`${classes.frequentQuestionsButton}`}
                />
            </Box>
        );
    }

    const setFirstDate = (value) => {
        dispatch(setFilters({ ...refundsFilters, dateStart: value }));
    }

    const setEndDate = (value) => {
        dispatch(setFilters({ ...refundsFilters, dateEnd: value }));
    }

    const validateInitialValues = () => {
        let aux = {};
        if (refundsFilters) {
            aux = { ...refundsFilters };

            if (refundsFilters?.dateStart == null) {
                aux = { ...aux, dateStart: date.setMonth(date.getMonth() - previousSixMonths) };
            }

            if (refundsFilters?.dateEnd == null) {
                aux = { ...aux, dateEnd: new Date() };
            }
        }
        dispatch(setFilters(aux));
    }



    const refundsCard = (element, index) => {
        return (
            <MovementsCard
                index={index}
                headerIcon={
                    <HeaderCard
                        day={element?.fechaFormateada?.nombreDia}
                        numberDay={element?.fechaFormateada?.dia}
                        month={parseInt(element?.reintegroGestionFecha?.substring(5, 7))}
                        year={parseInt(element?.reintegroGestionFecha?.substring(0, 4))} />
                }
                description={
                    <Box style={{ marginTop: '5px' }}>
                        <Typography style={{ fontWeight: "600" }} className={`${classes.txtCardDescription} ${classes.movementsCardDescription}`}>
                            {`SOLICITUD N°: ${element?.reintegroGestionCodigo}`}
                        </Typography>
                        <Typography className={`${classes.txtCardDescription}`} style={{ width: screen.sWidth < 768 && '150px' }}>
                            {`PRESTACION: ${element?.reintegroTipoDescripcion}`}
                        </Typography>
                        <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis} ${classes.txtDescriptionRefunds}`}>
                            REINTEGRO Nº {element?.reintegroNumero !== 0 ? element?.reintegroNumero : "-"}
                        </Typography>
                        <Typography className={`${classes.txtCardDescription}`}>
                            {`IMPORTE: $ ${element?.reintegroImporte}`}
                        </Typography>
                        <Typography className={`${classes.txtCardDescription} ${classes.movementsCardDescription}`}>
                            {`ESTADO:`} {element?.reintegroEstadoDescripcion}
                        </Typography>
                    </Box>
                }
                buttonZone={
                    <Box className={classes.buttonZoneSection}>
                        <Box className={`${classes.sectionButtons} ${classes.btnAuthorizationCard} ${classes.buttonZoneContainer}`}>
                            <Box>
                                <IconButton onClick={handleClickVerMas(element)} customClass={`${classes.customHeaderBtn}`}>
                                    <Typography className={`${classes.seeMoreButton} ${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                        VER
                                    </Typography>
                                    <ControlPointOutlinedIcon className={`${classes.iconFilter} ${classes.seeMoreIcon}`} />
                                </IconButton>
                            </Box>
                            <Box style={{ paddingRight: '7%' }}>
                                {setButtons(element)}
                            </Box>
                        </Box>
                    </Box>
                }
            />
        );
    }

    const downloadPopUp = () => {
        return (
            <ModalActivities
                title={
                    <Box className={classes.titleModal}>
                        <Typography>Descargar</Typography>
                    </Box>
                }
                description={
                    <Box className={classes.descriptionModal}>
                        <Box component="a" href={`data:image/png;base64,${itemSelected?.archivo}`} download={itemSelected?.archivoNombreCompleto}>
                            <IconButton style={{ backgroundColor: '#ffffff', borderRadius: '15px' }}>
                                <FileDownloadIcon className={classes.actionsIcons} />
                            </IconButton>
                        </Box>
                    </Box>
                }
                open={openModal}
                onClose={setOpenModal}
                modalconfirm={false}
                modalLogout={false}
            />
        );
    }

    const handleClickVerMas = (item) => (e) => {
        e.preventDefault();
        let obj = {
            numeroPersona: refundsFilters?.afiliado?.value,
            gestionCodigo: item.reintegroGestionCodigo,
            reintegroNumero: item.reintegroNumero,
            delegacionCodigo: item.reintegroDelegacionCodigo
        };
        let afiliado = refundsFilters?.afiliado?.value;
        history.push('/RefundsDetails', { params: [obj, afiliado] });
    };

    useEffect(() => {
        setOpenModal(false);
    }, [])

    return (
        <>
            <Box className={`${classes.divIndexRefunds}`}>
                {startRequestButton()}

                <Box className={`${classes.divAccordionPrograms} ${classes.selectAffiliateContainer}`}>
                    {affiliateDropDown()}
                    {frequentQuestionsButton()}
                </Box>

                <Box className={classes.historyAndFilterButtonContainer}>
                    <Box style={{ display: "flex", alignItems: "center" }}>
                        <Typography className={`${classes.textTitleTurn} ${classes.titleRefunds}`}>
                            Historial
                        </Typography>
                    </Box>
                    <ShowPeriodFilter
                        dateStart={refundsFilters['dateStart']}
                        dateEnd={refundsFilters['dateEnd']}
                        setDateStart={setFirstDate}
                        setDateEnd={setEndDate}
                        openPicker={openPicker}
                        setOpenPicker={setOpenPicker}
                        classes={classes}
                    />
                </Box>

                <Divider className={`${classes.formDivider} ${classes.dividerAppointment}`} />

                <Box className={`${classes.listCardMyHistory} ${classes.refundsCardsContainer}`}>
                    {
                        (refundsFilters?.afiliado?.value !== undefined && listCard?.length > 0) ?
                            listCard?.map((item, i) => (
                                <Box key={item?.id} style={{ margin: '5px' }}>
                                    {refundsCard(item, i)}
                                </Box>
                            ))
                            :
                            <NotFound
                                loading={refundsRedux?.loading}
                                customMsg={
                                    <Box className={classes.contentNotFound}>
                                        <Typography>No tenés historial de reintegros</Typography>
                                    </Box>
                                }
                                wsItem={refundsRedux?.refunds?.reintegros}
                                fullItem={refundsRedux?.refunds?.reintegros}
                            />
                    }
                </Box>
            </Box>

            {openModal && downloadPopUp()}

            {
                openCancelRefundModal &&
                <ModalActivities
                    title={'Anular solicitud'}
                    description={
                        <>
                            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                Estás por anular la solicitud de reintegro seleccionada
                            </Box>
                            <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                ¿Querés continuar?
                            </Box>
                        </>
                    }
                    onClose={setOpenCancelRefundModal}
                    open={openCancelRefundModal}
                    modalconfirm={true}
                    buttonType={'submit'}
                    handleClick={handleClickCancelRefund()}
                    modalLogout={false}
                    style={{ textAlign: 'center' }}
                />
            }

            {
                openLoadingModal &&
                <ModalActivities
                    title={
                        <Box style={{ marginTop: "30px" }}>Preparando archivo ...</Box>
                    }
                    description={
                        <Box className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.whiteCircularProgress}`}>
                            <CircularProgress />
                        </Box>
                    }
                    onClose={handleCloseDownload}
                    open={openLoadingModal}
                    modalconfirm={false}
                    modalLogout={false}
                    style={{ textAlign: 'center' }}
                />
            }

            {
                openNullifyRefundModal &&
                <ModalActivities
                    title={
                        <Box style={{ marginTop: "30px" }}>Anulando solicitud ...</Box>
                    }
                    description={
                        <Box
                            className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.whiteCircularProgress}`}>
                            <CircularProgress />
                        </Box>
                    }
                    onClose={setNullifyRefundModal}
                    open={openNullifyRefundModal}
                    style={{ textAlign: 'center' }}
                    modalconfirm={false}
                    modalLogout={false}
                />
            }

            {
                ErrorDownloadModal &&
                <ModalActivities
                    description={
                        <>
                            <Box>Ocurrió un error al intentar obtener el archivo</Box>
                            <Box>Por favor, intentá de nuevo más tarde</Box>
                        </>
                    }
                    title={<CancelIcon className={`${classes.quickAccessIcon} ${classes.personalDataIcon}`} />}
                    modalLogout={false}
                    open={ErrorDownloadModal}
                    style={{ textAlign: 'center' }}
                    onClose={setErrorDownloadModal}
                    modalconfirm={false}
                />
            }

            {
                ErrorModal &&
                <ModalActivities
                    title={
                        <CancelIcon className={`${classes.quickAccessIcon} ${classes.personalDataIcon}`} />
                    }
                    description={
                        <Box>
                            <Box>Ocurrió un error al intentar anular la solicitud</Box>
                            <Box>Por favor, intentá de nuevo más tarde</Box>
                        </Box>
                    }
                    onClose={setErrorModal}
                    open={ErrorModal}
                    style={{ textAlign: 'center' }}
                    modalconfirm={false}
                    modalLogout={false}
                />
            }

            {showErrorMessageModalRetry(errorMessage, openErrorModal, setOpenErrorModal, classes.borderWhite, classes.quickAccessIcon, classes.contentDialogTitle, "/Refunds", resetRefundError)}
        </>
    );
};

export default RefundsIndex;
